
/** Recibe un objeto como por ejemplo una Enum y retorna un listado de objetos con value y text */
export function mapToSelect(obj: any) {
  return Object.entries(obj).map(([value, text]) => ({ text, value }));
}
import { Options, Vue } from 'vue-class-component';
import { COMBO_LINKS, JURISDICCIONES, KEYS_JURISDICCIONES } from '@/api/StaticApi';
import Link from '@/model/Link';

@Options({
  components: {},
  name: 'PadronInscripciones',
})
export default class PadronInscripciones extends Vue {
  options = mapToSelect(JURISDICCIONES);
  model: KEYS_JURISDICCIONES = 'CAPITAL_FEDERAL';
  get links(): Link[] {
    return COMBO_LINKS.find((link) => link.id === this.model)?.links.sort((a,b) => a.descripcion.localeCompare(b.descripcion, 'es', { sensitivity: 'base' })) || [];
  }
  download(link: string) {
    window.open(link);
  }
}
